module.exports = __webpack_public_path__ + "static/img/list-img3.c06490a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/list-img3.png
// module id = AcEx
// module chunks = 0